export function isPlainClick(event) {
    if (event.metaKey || event.altKey || event.shiftKey || event.ctrlKey) {
        return false;
    }
    return true;
}
export function isLeftClick(event) {
    if (event.hasOwnProperty('buttons') && event.buttons) {
        return event.buttons === 1;
    }
    var button = event.nativeEvent.which || event.button;
    return button < 2;
}
export var MouseButton;
(function (MouseButton) {
    MouseButton[MouseButton["Other"] = -1] = "Other";
    MouseButton[MouseButton["Main"] = 0] = "Main";
    MouseButton[MouseButton["Auxiliary"] = 1] = "Auxiliary";
    MouseButton[MouseButton["Secondary"] = 2] = "Secondary";
})(MouseButton || (MouseButton = {}));
export function getClickType(event) {
    var buttonClicked = event.which - 1 || event.button;
    if (buttonClicked < 0 || buttonClicked > 2) {
        return MouseButton.Other;
    }
    return buttonClicked;
}
//# sourceMappingURL=clickHelpers.js.map